import React from 'react'
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
   
    <div className='bg-white mt-3 border-top'>
       <Container>
         <div className="col-md-12 bg-light pb-2 pt-2">
        <div className="row m-0" >
          <div className="col-lg-12 ">
            <p className="small mb-4 mb-lg-0 pt-2 text-center">© 2024 INSURANCE EXCHANGE DATA SERVICES LLC.</p>
          </div>
          
          </div>
      </div>
      </Container>
    </div>
   
  )
}

export default Footer